import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ListColumnCheckboxDirective } from "@components/list/list-column-checkbox.directive";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent as ListComponent_1 , ListComponent } from "@components/list/list.component";
import { orderBy } from "lodash";
import { Observable, Subject, combineLatest } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { IProduktinstruktionSearchResult } from "../models/IProduktinstruktionSearchResult";
import { IProduktdefinitionBasdata } from "../models/ProduktdefinitionModels";
import { ProduktinstruktionViewModel } from "../models/produktinstruktionViewModel";
import { ProduktinstruktionService } from "../services/produktinstruktion.service";

@Component({
    selector: "rask-produktinstruktioner-search-result",
    templateUrl: "./produktinstruktioner-search-result.component.html",
    styleUrls: ["./produktinstruktioner-search-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent_1,
        ListColumnCheckboxDirective,
        ListColumnDirective,
        RouterLink
    ]
})
export class ProduktinstruktionerSearchResultComponent implements OnInit, OnDestroy {
    basData: IProduktdefinitionBasdata;
    @Input() events: Observable<void>;
    @Input() massEditEvent: Observable<void>;
    searchResult: ProduktinstruktionViewModel[];
    @ViewChild("searchresult") searchResultTable: ListComponent;
    selectedRows: ProduktinstruktionViewModel[];

    private readonly produktinstruktionService = inject(ProduktinstruktionService);
    private readonly router = inject(Router);
    private readonly unsubscribe$ = new Subject<void>();

    massEditPin() {
        const valdaProduktinstruktioner = this.searchResultTable.getSelectedRows();
        this.produktinstruktionService.validateMasseditProduktinstruktioner(valdaProduktinstruktioner.map(x => x.puid)).subscribe(x => {
            const puids = valdaProduktinstruktioner.map(y => y.puid);
            this.router.navigate([
                "produktinstruktioner/massedit",
                puids.join(",")
            ]);
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        combineLatest([
            this.produktinstruktionService.getProduktinstruktionBasData(),
            this.produktinstruktionService.searchResult$
        ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(x => {
                const [
                    basData,
                    searchResult
                ] = x;
                this.basData = basData;
                this.onSearchResultChanged(searchResult);
            });

        this.massEditEvent.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.massEditPin());
    }

    onCheckedChange() {
        this.selectedRows = this.searchResultTable.getSelectedRows();
    }

    onSearchResultChanged(result: IProduktinstruktionSearchResult[]) {
        this.searchResult = result.map(y => new ProduktinstruktionViewModel(y, this.basData));
        this.searchResult = orderBy(this.searchResult, g => g.namn, "asc");
        this.selectedRows = [];
    }
}
